export default "__VITE_ASSET__t9A8iS55__"